import { APP_ENVIRONMENT } from 'config'

export function isEqual(a, b) {
  // Create arrays of property names
  const aProps = Object.getOwnPropertyNames(a)
  const bProps = Object.getOwnPropertyNames(b)

  // If number of properties is different,
  // objects are not equivalent
  if (aProps.length !== bProps.length) {
    return false
  }

  for (let i = 0; i < aProps.length; i++) {
    const propName = aProps[i]

    if (a[propName] !== b[propName]) {
      return false
    }
  }

  // If we made it this far, objects
  // are considered equivalent
  return true
}

export function getSplitName(name) {
  const names = name.split(' ')
  const firstName = names.splice(0, 1)
  const lastName = names.join(' ')

  return {
    firstName: firstName[0],
    lastName
  }
}

export function getPaginationObject(state, newValues, loaded) {
  return {
    ...state,
    filters: {
      ...state.filters,
      pagination: {
        ...state.filters.pagination,
        ...newValues
      },
      loaded
    }
  }
}

export function getGoogleApiKey() {
  return process.env.REACT_APP_GOOGLE_API_KEY
}

export function getObjectWithUuid(array, uuid) {
  let iterator = 0

  while (iterator < array.length - 1) {
    if (array[iterator].uuid === uuid) {
      break
    } 

    iterator += 1
  }

  return array[iterator]
}

export function addTestAutomationClassName(className) {
  // className format should follow [qa-scope-type-name] e.g. 'qa-signin-field-email'

  // environments which className will be added.
  const environments = ['development', 'qa']

  return environments.some(env => env === APP_ENVIRONMENT) ? className : null
}

export function filterActiveTraps(traps) {
  return Object.fromEntries(Object.entries(traps).filter(([, value]) => value.active))
}

export function convertHistoryUuidToTrapUuid(historyUuids, allTraps) {
  return historyUuids.map(uuid => allTraps[uuid].trapUuid)
}

export const convertArrayToObject = (array, key) => {
  const initialValue = {}
  return array.reduce((obj, item) => {
    return {
      ...obj,
      [item[key]]: item,
    }
  }, initialValue)
}

export const emailReg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/



// WEBPACK FOOTER //
// ./src/utils/misc.js